module.exports = __webpack_public_path__ + "img/aeroland-client-logo-01.ad3969cc.png";